module.exports = __webpack_public_path__ + "images/a25b000189b32e48eea67d7cae5e5267.svg";